module.exports = __webpack_public_path__ + "img/icon-OUT.e3646370.png";